export default "__VITE_ASSET__BLUuzhGL__"